/* RESPONSIBLE TEAM: team-automation-foundations */
import type Transition from '@ember/routing/transition';
import ProceduresIndexRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/index';

export default class FinAiAgentEcommerceProceduresIndexRoute extends ProceduresIndexRoute {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.ecommerce.procedures',
  };

  async beforeModel(transition: Transition) {
    if (!this.appService.app.canUseFinProcedures) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.ecommerce.tasks', {
        queryParams: transition.to?.queryParams || {},
      });
      return;
    }

    await super.beforeModel(transition);
  }
}
